import { type TComment } from '@core/models'
import { convertComment } from '@core/converters'

import { useAudioScreenLoaderData } from './useAudioScreenLoaderData'

export const useAudioScreenComments = (): TComment[] | undefined => {
    const { comments } = useAudioScreenLoaderData()

    return comments?.map(convertComment)
}
